import { makePendenciesRepository } from 'modules/customer/infra/repositories';

import { FetchPendenciesUseCase } from './implementations/FetchPendenciesUseCase';

let instance: FetchPendenciesUseCase | null = null;

export default function makeFetchPendenciesUseCase() {
  if (!instance) {
    const repository = makePendenciesRepository();

    instance = new FetchPendenciesUseCase(repository);
  }

  return instance;
}
